import React, { Component } from 'react';

export default class CommonModal extends Component {

    render() {
        return (
            <div id="common-modal"
                className="modal fade"
                role="dialog"
                aria-labelledby="myModalLabel"
                aria-hidden="true">

                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                {
                                    this.props.hideCrossButton &&
                                    <button type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={this.props.toggleCommonModal}
                                    >
                                        <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                                    </button>
                                }
                            </div>
                            <div className="modal-body">
                                <p><strong>{this.props.message}</strong></p>
                            </div>
                            <div className="modal-footer">
                                <button type="button"
                                    className="btn btn-outline-primary"
                                    onClick={this.props.toggleCommonModal}>OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}